// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2IKGY","content":"styles_content__16n6r","checkbox":"styles_checkbox__3CNvs","checkboxLabel":"styles_checkboxLabel__1u3IW"};